import { partyColors } from "@/lib/party";

export default function PartyChip({ short, label, size = "sm" }) {
  const c = partyColors(short);
  const text = label || short;
  const sizing = size === "lg" ? "text-sm px-3 py-1.5" : "text-[13px] px-2.5 py-1";
  return (
    <span
      className={`party-chip inline-flex items-center gap-1.5 rounded-full font-semibold ${sizing}`}
      style={{ background: c.bg, color: c.text }}
      data-testid={`party-chip-${short}`}
    >
      <span
        className="party-dot inline-block w-2.5 h-2.5 rounded-full"
        style={{ background: c.dot, boxShadow: `0 0 0 2px ${c.bg}` }}
      />
      {text}
    </span>
  );
}
